import { createContext, useContext, useMemo } from "react";

/**
 * @param {object} apacConfigurationsData - Raw entry from Contentful.
 * @returns {object} Merged translations config (empty object if none found).
 */

const ApacConfigurationsContext = createContext({
  apacConfigurationsData: {},
  formConfigurationsData: {},
});

export const ApacConfigurationsProvider = ({
  apacConfigurationsData = {},
  formConfigurationsData = {},
  children,
}) => {
  const value = useMemo(
    () => ({
      apacConfigurationsData,
      formConfigurationsData,
    }),
    [apacConfigurationsData, formConfigurationsData] // Added dataList dependency
  );

  return (
    <ApacConfigurationsContext.Provider value={value}>
      {children}
    </ApacConfigurationsContext.Provider>
  );
};

export const useApacConfigurations = () =>
  useContext(ApacConfigurationsContext).formConfigurationsData;
export const useContentfulTranslations = () =>
  useContext(ApacConfigurationsContext).apacConfigurationsData;
